/* 2009-2018 Copyright Ridecell Inc. All rights reserved. */
/* eslint-disable no-restricted-syntax */
import window from '../util/window'

function isFormLiteral(value) {
  return typeof value === 'number' || typeof value === 'string' || typeof value === 'boolean'
}

export default class FormDataSerializer {
  // eslint-disable-next-line class-methods-use-this
  serialize(obj) {
    const form = new window.FormData()
    for (const key of Object.keys(obj)) {
      const value = obj[key]
      if (Array.isArray(value)) {
        // django rest framework uses a QueryDict and can support multiple values
        // for the same field.
        // https://github.com/tomchristie/django-rest-framework/blob/a335309b33e5e99a968d36a0a778e0872adab3a8/rest_framework/relations.py#L463
        for (const item of value) {
          if (isFormLiteral(item)) {
            form.append(key, String(item))
          }
        }
      } else if (value === null) {
        // django rest framework converts empty strings to None if field is nullable
        // https://github.com/tomchristie/django-rest-framework/blob/a335309b33e5e99a968d36a0a778e0872adab3a8/rest_framework/fields.py#L393
        form.append(key, '')
      } else if (isFormLiteral(value)) {
        // django rest framework can convert 'true' and 'false' to True and False
        // https://github.com/tomchristie/django-rest-framework/blob/a335309b33e5e99a968d36a0a778e0872adab3a8/rest_framework/fields.py#L613
        form.append(key, String(value))
      } else if (value instanceof window.File || value instanceof window.Blob) {
        form.append(key, value)
      } else if (typeof value === 'object') {
        // send field as a JSON object
        form.append(key, new window.Blob([JSON.stringify(value)], { type: 'application/json' }))
      }
    }
    return form
  }
}
